import { SmartClassifierState } from "./types";

/**
 * Initial state for the Smart Classifier module.
 * Starts with empty intents array and no active operations.
 */
const state: SmartClassifierState = {
  intents: [],
  fallback: "",
  isFetching: false,
};

export default state;
